import { createSlice } from "@reduxjs/toolkit";

export interface Token {
  loginToken: string;
  accessToken: string;
}

export const initialState: Token = {
  loginToken: "",
  accessToken: "",
};

export const tokenSlice = createSlice({
  name: "token",
  initialState,
  reducers: {
    update: (state, params) => {
      const f = params.payload as any;
      state.loginToken = f.loginToken;
      state.accessToken = f.accessToken;
    },
  },
});

// Action creators are generated for each case reducer function
export const { update } = tokenSlice.actions;

export default tokenSlice.reducer;
